import PropTypes from 'prop-types'
import React from 'react'
import injectSheet from 'react-jss'
import { Col, Row } from 'react-bootstrap'
import Titre1 from './font/Titre1'
import Titre5 from './font/Titre5'
import { Link } from 'react-router-dom'
import routes from '../routing/routes'
import P from './font/P'
import responsiveComponent from '../hoc/responsiveComponent'
import ImageLoader from './ImageLoader'
import LazyLoad from 'react-lazy-load'

const styles = theme => ({
  /// ////////////Pour les deux formats///////////////////
  wrapper: {
    margin: '0px',
    textAlign: 'left'
  },
  hr: {
    borderColor: theme.producteur.hrColor,
    margin: 0
  },
  categorie: {
    textAlign: 'left',
    marginBottom: 0
  },
  lienFiche: {
    display: 'inline',
    color: theme.lien,
    fontWeight: theme.bold,
    '&:hover': {
      color: theme.lien
    }
  },
  oeil: {
    margin: '0px 5px -5px 0px'
  },
  linkToProducers: {
    '&:hover': {
      textDecoration: 'none'
    }
  },
  commDep: {
    display: 'inline',
    textTransform: 'capitalize',
    verticalAlign: 'top'
  },
  infoFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 5,
    alignItems: 'start'
  },
  presentation: {
    wordBreak: 'break-word'
  },
  /// ////////////////////Mobile////////////////////////////
  wrapperProducer: {
    padding: '15px 0px'
  },
  titreProd: {
    marginTop: '15px',
    textTransform: 'uppercase',
    '& a': {
      color: theme.titre1
    }
  },
  imageContainer: {
    textAlign: 'center',
    height: 300
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%'
  },
  /// //////////////////Autre Format (AF)/////////////////////
  wrapperProducerAF: {
    padding: 15,
    '&:hover': {
      backgroundColor: theme.listeProducteur.hoverColor
    }
  },
  imageAF: {
    width: '100%',
    paddingTop: '90%',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    position: 'relative'
  },
  imageContainerAF: {
    textAlign: 'center',
    padding: '0 0 0 15px'
  },
  infoProdAF: {
    textAlign: 'left'
  },
  titreProdAF: {
    textTransform: 'uppercase',
    '& a': {
      color: theme.titre1
    }
  }
})

const Producteur = ({
  classes,
  id,
  photosProducer,
  photoUrlProducer,
  companyName,
  commune,
  dep,
  categories,
  presentation,
  isMobile,
  isLast,
  distance
}) => {
  const image =
    photoUrlProducer ||
    (photosProducer && photosProducer.length > 0
      ? photosProducer[0].cloudPath
      : '/img/no_photo.jpg')

  return (
    <div className={classes.wrapper}>
      {isMobile ? (
        <div className={classes.wrapperProducer}>
          <Link
            to={routes.ficheProducteur.replace(':id(\\d+)', id)}
            className={classes.linkToProducers}
          >
            <div className={classes.imageContainer}>
              <LazyLoad
                width={'100%'}
                height={300}
                debounce={false}
                offsetVertical={1200}
              >
                <ImageLoader
                  className={classes.image}
                  src={image}
                  alt={companyName}
                />
              </LazyLoad>
            </div>

            <Titre1 component='p' className={classes.titreProd}>
              {companyName}
            </Titre1>
          </Link>

          {distance && (
            <Titre5 component='p'>{Math.round(distance * 100) / 100} km</Titre5>
          )}

          <P className={classes.presentation}>
            {presentation && presentation.length > 300
              ? presentation.substr(0, 300) + '...'
              : presentation}
          </P>

          <div className={classes.infoFooter}>
            {categories && (
              <>
                <Titre5 component='p' className={`${classes.categorie}`}>
                  {categories.length > 0
                    ? categories.length > 1
                      ? 'Catégories:'
                      : 'Catégorie:'
                    : ''}
                  {categories
                    .map(
                      categorie =>
                        ` ${
                          typeof categorie === 'string'
                            ? categorie
                            : categorie.reference
                        } `
                    )
                    .join('-')}
                </Titre5>
              </>
            )}

            <span>
              <Titre5 component='p' className={`${classes.commDep}`}>
                {dep && dep !== ' ' ? `${commune} -` : commune}{' '}
              </Titre5>
              <Titre5 component='p' jaune className={`${classes.commDep}`}>
                {dep}
              </Titre5>
            </span>
          </div>
        </div>
      ) : (
        // Desktop format //
        <Link
          to={routes.ficheProducteur.replace(':id(\\d+)', id)}
          className={classes.linkToProducers}
        >
          <div className={classes.wrapperProducerAF}>
            <Row>
              <Col sm={6} className={classes.imageContainerAF}>
                <LazyLoad width={'100%'} debounce={false} offsetVertical={1200}>
                  <div
                    className={classes.imageAF}
                    role='img'
                    aria-label={companyName}
                    style={{ backgroundImage: `url(${image})` }}
                  />
                </LazyLoad>
              </Col>

              <Col sm={6} className={classes.infoProdAF}>
                <Titre1 component='p' className={classes.titreProdAF}>
                  {companyName}
                </Titre1>
                {distance && (
                  <Titre5 component='p'>
                    {Math.round(distance * 100) / 100} km
                  </Titre5>
                )}

                <P className={classes.presentation}>
                  {presentation && presentation.length > 300
                    ? presentation.substr(0, 300) + '...'
                    : presentation}
                </P>
              </Col>
            </Row>

            <div className={classes.infoFooter}>
              {categories && (
                <Titre5 component='p' className={classes.categorie}>
                  {categories.length > 0
                    ? categories.length > 1
                      ? 'Catégories:'
                      : 'Catégorie:'
                    : ''}
                  {categories
                    .map(
                      categorie =>
                        ` ${
                          typeof categorie === 'string'
                            ? categorie
                            : categorie.reference
                        } `
                    )
                    .join('-')}
                </Titre5>
              )}

              <span>
                <Titre5 component='p' className={classes.commDep}>
                  {dep && dep !== ' ' ? `${commune} -` : commune}{' '}
                </Titre5>
                <Titre5 component='p' jaune className={classes.commDep}>
                  {dep}
                </Titre5>
              </span>
            </div>
          </div>
        </Link>
      )}

      {!isLast && <hr className={classes.hr} />}
    </div>
  )
}

export default responsiveComponent(injectSheet(styles)(Producteur))

Producteur.propTypes = {
  categories: PropTypes.array,
  commune: PropTypes.string,
  companyName: PropTypes.string,
  dep: PropTypes.string,
  distance: PropTypes.any,
  id: PropTypes.any,
  isLast: PropTypes.bool,
  photoUrlProducer: PropTypes.string,
  photosProducer: PropTypes.array,
  presentation: PropTypes.string
}
